import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

const ACCEPT_INVITE_PATH = '/auth/accept-invite';

interface RequireCompletedInviteProps {
  children: ReactNode;
}

/**
 * Leitet eingeladene Nutzer auf die Passwortvergabe, solange sie diese nie
 * durchlaufen haben.
 *
 * Die Erkennung des Einladungs-Callbacks haengt sonst allein am URL-Fragment
 * (`type=invite` in AuthCallbackPage). Wer stattdessen per Magic-Link
 * hereinkommt, laeuft an der Passwortvergabe vorbei und hat dauerhaft kein
 * Passwort, das er kennt. Diese Weiche greift unabhaengig vom Einstiegsweg bei
 * jedem Aufruf einer geschuetzten Seite.
 *
 * Das Signal ist `invitation_pending` aus /api/auth/me - ob ein Konto ueberhaupt
 * ein Passwort hat, laesst sich bei Supabase nicht ermitteln (siehe #512).
 */
export const RequireCompletedInvite = ({
  children,
}: RequireCompletedInviteProps) => {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  // Ohne Weiterleitung auf der Zielseite selbst - sonst Redirect-Schleife
  if (user?.invitation_pending && location.pathname !== ACCEPT_INVITE_PATH) {
    return <Navigate to={ACCEPT_INVITE_PATH} replace />;
  }

  return <>{children}</>;
};
